import { Stack, Switch, Typography } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { useColorMode } from "./themeMode";

/**
 * Toggles appearance for the current route context only (public vs app storage),
 * wired by `RootTheme` in `index.js`.
 */
export default function PublicThemeToggle({ showLabel = true }) {
  const { mode, setColorMode } = useColorMode();
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ py: 0.5, flexShrink: 0 }}
    >
      <LightModeOutlinedIcon sx={{ fontSize: 18, opacity: mode === "light" ? 1 : 0.35 }} color="action" />
      <Switch
        size="small"
        checked={mode === "dark"}
        onChange={(_, c) => setColorMode(c ? "dark" : "light")}
        inputProps={{ "aria-label": "Use dark appearance on this page" }}
        color="default"
      />
      <DarkModeOutlinedIcon sx={{ fontSize: 18, opacity: mode === "dark" ? 1 : 0.35 }} color="action" />
      {showLabel ? (
        <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.25, display: { xs: "none", sm: "inline" } }}>
          Appearance
        </Typography>
      ) : null}
    </Stack>
  );
}
